export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00479.f10d17a3.png";